module.exports = __webpack_public_path__ + "static/media/repeat.dd106215.svg";